import { FC } from 'react';

import {
  ContentHeader,
  LayoutWithNavigationBreadcrumbs,
  NavigationBreadcrumbsTitles,
} from 'components';
import { Stack } from 'libs/ui';

import {
  CreateOrderForm,
  CreateOrderFormContent,
  CreateOrderFormFooter,
  CreateOrderFormProps,
} from '../../component';

export interface CreateOrderViewProps extends CreateOrderFormProps {
  breadcrumbsTitles?: NavigationBreadcrumbsTitles;
  submitLoading?: boolean;
  title: string;
  onBack: () => void;
}

export const CreateOrderView: FC<CreateOrderViewProps> = ({
  breadcrumbsTitles,
  submitLoading,
  title,
  onBack,
  ...formProps
}) => (
  <LayoutWithNavigationBreadcrumbs titles={breadcrumbsTitles}>
    <CreateOrderForm {...formProps}>
      <Stack spacing={24}>
        <ContentHeader header={title} />
        <CreateOrderFormContent />
        <CreateOrderFormFooter submitLoading={submitLoading} onBack={onBack} />
      </Stack>
    </CreateOrderForm>
  </LayoutWithNavigationBreadcrumbs>
);
